import { ENDPOINT } from '~/constants/endpoints';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { withoutObjectKeysWhereValueIs } from '@vestigas/utils';

import {
  type NetworkSuppliersQueryParams,
  type NetworkSuppliersResponse,
} from './types';
import {
  zodNetworkSuppliersQueryParamsSchema,
  zodNetworkSuppliersResponseSchema,
} from './validations';

/**
 * Fetches the network catalog of visible suppliers.
 *
 * Pass `isRelevant=false` to exclude suppliers already marked as relevant.
 *
 * @param queryParams - Filter and pagination parameters; `recipientCompanyIds` is required.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The paginated network suppliers response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Suppliers/operation/get_network_suppliers_suppliers_network_get
 */
export const fetchNetworkSuppliers = async (
  queryParams: Partial<NetworkSuppliersQueryParams>,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.SUPPLIER.GET_NETWORK(), {
      ...options,
      searchParams: queryParams,
      validate: {
        ...options?.validate,
        response: zodNetworkSuppliersResponseSchema,
        searchParams: zodNetworkSuppliersQueryParamsSchema.transform((value) =>
          withoutObjectKeysWhereValueIs(value, [null, undefined, '']),
        ),
      },
    })
    .json<NetworkSuppliersResponse>();
